import { useField } from 'react-final-form';

export const useFormVehicleId = () => {
  const {
    input: { value: vehicleId }
  } = useField('vehicleId');

  return Number(vehicleId);
};
